export default __webpack_public_path__ + "static/media/817HEQEQGbL.0ac096cb.jpg";